import { useEffect, useState } from "react";
import { authToken, createToken } from "../../services/authService";
import { useNavigate } from "react-router-dom";
import useErrorHandle from "../errorHandling/useErrorHandle";

import { getData } from "../../utiles/CookieUtile";

const useAuth = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const handleError = useErrorHandle();
  useEffect(() => {
    const initializeAuth = async () => {
      const accessToken = getData("accessToken");
      const refreshToken = getData("refreshToken");

      if (!accessToken && refreshToken) {
        try {
          const newAccessToken = await createToken(refreshToken);
          setLoggedIn(!!newAccessToken);
        } catch (error) {
          console.error("Error during token refresh:", error.message);
          setLoggedIn(false);
          navigate("/login");
        }
      } else if (accessToken) {
        try {
          await authToken(navigate, setLoggedIn,handleError);
        } catch (error) {
          handleError(error);
        }
      } else if (!loggedIn) {
        setLoggedIn(false);
        if (window.location.pathname !== "/login") {
          navigate("/login");
        }
      }

      setLoading(false);
    };

    initializeAuth();
  }, []);

  return { drawerOpen, setDrawerOpen, loggedIn, setLoggedIn, loading };
};

export default useAuth;
